<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { STATS } from '@/store/types';
import statsApi from '../../apis/stats.api';

export default {
  props: {
    type: {
      type: String,
      default: 'mode_share',
    },
    from: String,
    to: String,
    daySearch: String,
    from_connect: { type: String, default: null },
    to_connect: { type: String, default: null },
    connect2: { type: Boolean, default: false },
    compare: { type: Boolean, default: false },
  },

  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.useModeShareQuery({
      type: props.type,
      from: props.from,
      to: props.to,
      daySearch: props.daySearch,
      connect2: props.connect2,
      from_connect: props.from_connect,
      to_connect: props.to_connect,
    });
    if (!props.compare) {
      if (query.value) {
        store.commit(STATS.SET_MODE_MONTH_STATS_QUERY, query);
      }
    } else {
      store.commit(STATS.SET_MODE_MONTH_STATS_QUERY_COMPARE, query);
    }
    return { query };
  },
};
</script>
